import "./create/page";


// WEBPACK FOOTER //
// ./src/js/create.js